
// import React from 'react';
// import { CircularProgress, Box, Typography } from '@mui/material';
// import RideBookingCard from '../../components/RideBookingCard';
// import { TAB_TO_STATUS } from '../UserDashBoard';

// const EMPTY_MESSAGES = {
//   upcoming: 'No upcoming rides. Book one to get started!',
//   pending: 'No rides awaiting confirmation.',
//   completed: 'No completed rides yet.',
//   cancelled: 'No cancelled rides.',
// };

// export default function UserBookings({ status, bookings, loading, error }) {
//   // ✅ Loading state
//   if (loading) {
//     return (
//       <Box
//         display="flex"
//         flexDirection="column"
//         alignItems="center"
//         justifyContent="center"
//         py={6}
//       >
//         <CircularProgress />
//         <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
//           Loading your bookings...
//         </Typography>
//       </Box>
//     );
//   }

//   // ✅ Error state
//   if (error) {
//     return (
//       <Box display="flex" justifyContent="center" py={4}>
//         <Typography color="error">{error}</Typography>
//       </Box>
//     );
//   }

//   // ✅ Filter by selected tab
//   const targetStatus = TAB_TO_STATUS[status];
//   const filteredBookings = (bookings || []).filter(
//     (ride) => ride.isRideConfirmed === targetStatus
//   );

//   // ✅ Empty state
//   if (filteredBookings.length === 0) {
//     return (
//       <Box display="flex" justifyContent="center" py={4}>
//         <Typography color="text.secondary">
//           {EMPTY_MESSAGES[status] || 'No rides found.'}
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <div className="space-y-6">
//       {filteredBookings.map((ride) => (
//         <RideBookingCard key={ride.bookingId} ride={ride} />
//       ))}
//     </div>
//   );
// }

// src/components/RideBookingCard.js
import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';
import RideBookingCard from '../../components/RideBookingCard';
import { TAB_TO_STATUS } from '../UserDashBoard';

const EMPTY_MESSAGES = {
  upcoming: 'No upcoming rides. Book one to get started!',
  pending: 'No rides awaiting confirmation.',
  completed: 'No completed rides yet.',
  cancelled: 'No cancelled rides.',
};

export default function UserBookings({ status, bookings, loading, error }) {
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 6,
        }}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Loading your bookings...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  const targetStatus = TAB_TO_STATUS[status];

  const filteredBookings = (bookings || [])
    .filter((ride) => ride != null && ride.bookingId != null)
    .filter((ride) => ride.isRideConfirmed === targetStatus);

  if (filteredBookings.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <Typography color="text.secondary">
          {EMPTY_MESSAGES[status] || 'No rides found.'}
        </Typography>
      </Box>
    );
  }

  return (
    <div className="space-y-6">
      {filteredBookings.map((ride) => (
        <RideBookingCard key={ride.bookingId} ride={ride} />
      ))}
    </div>
  );
}